import axios from 'axios';
import { parseStyleCatalog } from '@/domain/design/style-catalog';
import type { IStyleCatalogResponse } from '@/interfaces/IStorefrontStyle';
import { Globals } from '@/modules/Globals';

export default class StorefrontCatalogService {
  /**
   * The storefront's style catalog (CON-10, `GET /__storefront/styles`, served
   * by the storefront, never under `/api/`, which Cloudflare sends to the API),
   * validated; null when the answer is not a usable catalog. Sent without
   * credentials: the endpoint answers `Access-Control-Allow-Origin: *`, which
   * browsers reject for credentialed requests, and
   * `axios.defaults.withCredentials` is true (`src/index.ts:10`). Same origin
   * in production (`https://queresto.com/__storefront/styles` from
   * `https://queresto.com/admin`, the same on bistrify.com), cross origin on
   * localhost (3000 → 8095).
   */
  static async getStyleCatalog(): Promise<IStyleCatalogResponse | null> {
    const res = await axios.get<unknown>(
      `${Globals.website}/__storefront/styles`,
      { withCredentials: false }
    );
    return parseStyleCatalog(res.data);
  }
}
